"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTerritoryPartOfGeo = exports.getTerritoriesMap = exports.getEquipmentItemId = exports.getListingItemId = void 0;
const base_1 = require("../base");
const erpnext_1 = require("./erpnext");
const GeoTerritoriesMap = {
    [base_1.Geo.UAE]: {
        [erpnext_1.UaeTerritories.AbuDhabi]: true,
        [erpnext_1.UaeTerritories.Ajman]: true,
        [erpnext_1.UaeTerritories.Dubai]: true,
        [erpnext_1.UaeTerritories.Fujairah]: true,
        [erpnext_1.UaeTerritories.RasAlKhaimah]: true,
        [erpnext_1.UaeTerritories.Sharjah]: true,
        [erpnext_1.UaeTerritories.UmmAlQuwain]: true
    },
    [base_1.Geo.SA]: {
        [erpnext_1.SaTerritories.Bahah]: true,
        [erpnext_1.SaTerritories.NorthernBorders]: true,
        [erpnext_1.SaTerritories.Jawf]: true,
        [erpnext_1.SaTerritories.Madinah]: true,
        [erpnext_1.SaTerritories.Qassim]: true,
        [erpnext_1.SaTerritories.Riyadh]: true,
        [erpnext_1.SaTerritories.EasternProvince]: true,
        [erpnext_1.SaTerritories.Asir]: true,
        [erpnext_1.SaTerritories["Ha'il"]]: true,
        [erpnext_1.SaTerritories.Jazan]: true,
        [erpnext_1.SaTerritories.Makkah]: true,
        [erpnext_1.SaTerritories.Najran]: true,
        [erpnext_1.SaTerritories.Tabuk]: true
    }
};
// items id helpers
const getListingItemId = (listingId) => `listing:${listingId}`;
exports.getListingItemId = getListingItemId;
const getEquipmentItemId = (equipmentId, geo) => `${geo}:${equipmentId}`;
exports.getEquipmentItemId = getEquipmentItemId;
const getTerritoriesMap = (geo) => {
    let map = {};
    switch (geo) {
        case base_1.Geo.UAE:
            map = Object.assign(Object.assign({}, GeoTerritoriesMap[base_1.Geo.UAE]), { [erpnext_1.RootTerritories.UnitedArabEmirates]: true });
            break;
        case base_1.Geo.SA:
            map = Object.assign(Object.assign({}, GeoTerritoriesMap[base_1.Geo.SA]), { [erpnext_1.RootTerritories.SaudiArabia]: true });
            break;
    }
    return map;
};
exports.getTerritoriesMap = getTerritoriesMap;
const isTerritoryPartOfGeo = (territory, geo) => {
    const map = (0, exports.getTerritoriesMap)(geo);
    return map[territory];
};
exports.isTerritoryPartOfGeo = isTerritoryPartOfGeo;
//# sourceMappingURL=helpers.js.map